

export default function MailList() {
    return (
        <div id="mc_embed_shell">
            <div id="mc_embed_signup" className="contact-form-ctr mail-form-ctr">
                <form action="https://gmail.us18.list-manage.com/subscribe/post?u=d9502485d6c1b635fd14c4912&amp;id=8590cfffd6&amp;f_id=00c610e7f0" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" className="validate" target="_self" novalidate="">
                    <div id="mc_embed_signup_scroll">
                        <div className="indicates-required subscribe-text">Get emails from us!</div>
                        <div className="mc-field-group">
                            <input type="email" name="EMAIL" className="required email" id="mce-EMAIL" required="" placeholder="Your Email Address" />
                            <button type="submit" name="subscribe" id="mc-embedded-subscribe" className="button" value="Subscribe" >Subscribe</button>
                        </div>
                        <div aria-hidden="true" style={{ position: "absolute", left: "-5000px" }}>
                            <input type="text" name="b_d9502485d6c1b635fd14c4912_8590cfffd6" tabindex="-1" value="" />
                        </div>
                    </div>
                </form>
            </div>
        </div>

    )
}



